import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { CardsPage } from './pages/CardsPage';
import { LearnPage } from './pages/LearnPage';
import { AdminPage } from './pages/AdminPage';
import { LoginScreen } from './components/LoginScreen';

const App: React.FC = () => {
  const [pin, setPin] = useState<string | null>(localStorage.getItem('app_pin'));

  if (!pin) {
    return <LoginScreen onLogin={(p) => {
      localStorage.setItem('app_pin', p);
      setPin(p);
    }} />;
  }

  return (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<CardsPage />} />
      <Route path="/learn" element={<LearnPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </BrowserRouter>
  );
};

export default App;
